import { render, staticRenderFns } from "./DraftComponent.vue?vue&type=template&id=5e3760c8&scoped=true&"
import script from "./DraftComponent.vue?vue&type=script&lang=js&"
export * from "./DraftComponent.vue?vue&type=script&lang=js&"
import style0 from "./DraftComponent.vue?vue&type=style&index=0&id=5e3760c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3760c8",
  null
  
)

export default component.exports